import CTNDropdown from '@ctn/ui/components/ctn-dropdown';
import { type CTNDropdownOptionProps } from '@ctn/ui/types/ctn-dropdown';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import useOptionsStore from '@/store/options.store';

import { type SujetoForm } from '../config';

type Props = {
	readonly className?: string;
	readonly isDisabled?: boolean;
	readonly isDisplay?: boolean;
	readonly isDisplayTipoIntervencion?: boolean;
	readonly filterIntervencion?: number[];
};
const TipoInterviniente = ({ className, isDisabled, isDisplay, isDisplayTipoIntervencion, filterIntervencion }: Props) => {
	const {
		control,
		formState: { errors },
	} = useFormContext<SujetoForm>();

	const tipoPersona = useOptionsStore((state) => state.options.tramite?.tipoPersona) ?? [];
	const tipoIntervencion = useOptionsStore((state) => state.options.tramite?.tipoIntervencion) ?? [];

	const getFilterIntervencion = (options: CTNDropdownOptionProps[], filter?: number[]) => {
		if (filter) {
			return options.filter(({ value }) => filter.includes(Number(value)));
		}
		return options;
	};

	const filteredInternvencion = useMemo(
		() => getFilterIntervencion(tipoIntervencion, filterIntervencion),
		[tipoIntervencion],
	);

	const classNameTipoInterviniente = useMemo(
		() =>
			classNames(className, {
				['[ c-pnp-form-group ] [ u-flow ]']: isDisplay,
			}),
		[className, isDisplay],
	);

	return (
		<div className={classNameTipoInterviniente}>
			<div className="c-pnp-flow-grid">
				<CTNDropdown
					required={!isDisplay}
					displayOnly={isDisplay}
					condensed={isDisplay}
					noFeedBack={isDisplay}
					disabled={isDisabled}
					options={tipoPersona}
					classNameField="c-pnp-flow-grid__tipoper"
					name="idTipoPersona"
					label="Tipo de persona"
					control={control}
					appendTo="body"
					error={errors.idTipoPersona?.message}
				/>
				<CTNDropdown
					required={!isDisplay}
					displayOnly={isDisplayTipoIntervencion === null || isDisplayTipoIntervencion === undefined ? isDisplay : !isDisplayTipoIntervencion}
					condensed={isDisplay}
					noFeedBack={isDisplay}
					disabled={isDisplayTipoIntervencion ?? isDisabled}
					options={filteredInternvencion}
					classNameField="c-pnp-flow-grid__inter"
					name="idTipoIntervencion"
					label="Intervención"
					control={control}
					appendTo="body"
					error={errors.idTipoIntervencion?.message}
				/>
			</div>
		</div>
	);
};

export default TipoInterviniente;
